<template>
  <div>
    <label class="story-city-input-label d-flex align-center">
      <img
        class="story-city-label-icon"
        :src="require('@/assets/icons/time.svg')"
        alt=""
      />
      <div>{{ $t("story.duration") }}</div>
    </label>
    <v-text-field
      v-model="duration"
      class="story-city-text-input duration-input mb-1"
      placeholder="mm:ss"
      v-mask="'##:##'"
      hide-details="auto"
      flat
      outlined
      solo
    />
    <p
      v-if="duration"
      class="duration-text ma-0"
      v-html="
        $t('story.basicInfoForm.durationText', {
          hours: `<span>${$t('story.basicInfoForm.hours', { hours })}</span>`,
          minutes: `<span>${$t('story.basicInfoForm.minutes', { minutes })}</span>`,
        })
      "
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    disabled: Boolean,
  },
  data() {
    return {
      duration: this.value,
    };
  },
  computed: {
    hours() {
      return parseInt(this.duration.split(":")[0]);
    },
    minutes() {
      return parseInt(this.duration.split(":")[1]);
    },
  },
  watch: {
    value(newValue) {
      if (this.duration != newValue) {
        this.duration = newValue;
      }
    },
    duration(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.duration-input {
  max-width: 165px;
}

.duration-text {
  color: var(--v-textOnAccent-base);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: $font-spacing;
}

::v-deep .duration-text span {
  color: #20A5F5;
}
</style>
